import { useState } from "react";

const fmt = (m) =>
  `${String(Math.floor(m / 60) % 24).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

export default function CaffeineTimeline() {
  const [wake, setWake] = useState("07:00");
  const [h, m] = wake.split(":").map(Number);
  const wakeMins = h * 60 + m;
  const start = wakeMins + 90;
  const end = wakeMins + 120;
  const crash = wakeMins + 450;

  const rangeStart = 240;
  const rangeEnd = 1440;
  const pct = (v) =>
    Math.min(100, Math.max(0, ((v - rangeStart) / (rangeEnd - rangeStart)) * 100));

  return (
    <div data-testid="protocol-caffeine-timeline-widget" className="mt-6">
      <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#858599] block">
        Orario di risveglio
      </label>
      <input
        type="time"
        value={wake}
        onChange={(e) => e.target.value && setWake(e.target.value)}
        data-testid="caffeine-wake-input"
        className="mt-2 w-full bg-ink border border-white/10 text-white font-mono px-4 py-3 focus:border-neon focus:outline-none transition-colors [color-scheme:dark]"
      />
      <div className="relative h-2 bg-white/5 mt-8 mb-2">
        <div
          className="absolute top-0 bottom-0 bg-neon/60"
          style={{ left: `${pct(start)}%`, width: `${pct(end) - pct(start)}%` }}
        />
        <div
          className="absolute -top-1 w-0.5 h-4 bg-white"
          style={{ left: `${pct(wakeMins)}%` }}
        />
        <div
          className="absolute -top-1 w-0.5 h-4 bg-red-500/70"
          style={{ left: `${pct(crash)}%` }}
        />
      </div>
      <div className="flex justify-between font-mono text-[9px] uppercase tracking-[0.15em] text-[#858599]">
        <span>Risveglio {wake}</span>
        <span className="text-red-400/80">Crash evitato</span>
      </div>
      <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-white">
        Prima caffeina ottimale:{" "}
        <span className="text-neon">
          {fmt(start)} – {fmt(end)}
        </span>
      </p>
    </div>
  );
}
